import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersRoleplayingConditionTemplateMutateType,
  ApiManagersRoleplayingConditionTemplateMutateRequestType,
} from "~/domains";

type RequestDataType = {
  body: ApiManagersRoleplayingConditionTemplateMutateRequestType;
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersRoleplayingConditionTemplateMutateType>(
      "/api/managers/roleplaying_condition_templates",
      {
        roleplayingConditionTemplate: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersRoleplayingConditionTemplatesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersRoleplayingConditionTemplateMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
